import { createSlice } from '@reduxjs/toolkit';
import API from 'api/index.js';

const initialState = {
    incomingVehicles: [],
    incomingTransferVehicles: [],
    isOwnersCollapsed: true,
    isStationsCollapsed: true,
};

export const operatorIncomingSlice = createSlice({
    name: 'operatorIncoming',
    initialState,
    reducers: {
        setIsOwnersCollapsed: (state, { payload }) => { state.isOwnersCollapsed = payload; },
        setIsStationsCollapsed: (state, { payload }) => { state.isStationsCollapsed = payload; },
    },
    extraReducers: builder => {
        const {
            currentShopCarStatusSearchIncoming,
            currentShopCarStatusSearchTransfer,
            currentShopCarSingleUpdate,
        } = API.endpoints;

        builder
            .addMatcher(
                currentShopCarStatusSearchIncoming.matchFulfilled,
                (state, { payload }) => { state.incomingVehicles = payload; },
            )
            .addMatcher(
                currentShopCarStatusSearchTransfer.matchFulfilled,
                (state, { payload }) => { state.incomingTransferVehicles = payload; },
            )
            .addMatcher(currentShopCarSingleUpdate.matchFulfilled, (state, { payload, meta }) => {
                const { idCar } = meta.arg.originalArgs;
                const { status } = payload;

                const myCar = state.incomingVehicles.find(({ id }) => id === idCar);
                const transCar = state.incomingTransferVehicles.find(({ id }) => id === idCar);

                if(!myCar && !transCar && status !== 'shop_transit' && status !== 'shop_transfer') return;

                if(!myCar) {
                    if(status === 'shop_transit') state.incomingVehicles.push(payload);
                } else {
                    if(status === 'shop_transit') Object.assign(myCar, payload);
                    else state.incomingVehicles.splice(state.incomingVehicles.indexOf(myCar), 1);
                }

                if(!transCar) {
                    if(status === 'shop_transfer') state.incomingTransferVehicles.push(payload);
                } else {
                    if(status === 'shop_transfer') Object.assign(transCar, payload);
                    else state.incomingTransferVehicles.splice(state.incomingTransferVehicles.indexOf(transCar), 1);
                }
            });
    },
});

export const { setIsOwnersCollapsed, setIsStationsCollapsed } = operatorIncomingSlice.actions;

export default operatorIncomingSlice.reducer;
